import angular from "angular";
const debug = require("debug")("compliance:rp-select");

angular
  .module("fleetviewApp")
  .directive("routingProfileSelect", routingProfileSelect);

const vehicleTypeMap = {
  "Truck": "Heavy Duty",
  "MidsizeTruck": "Medium Duty",
  "LightDuty": "Light Duty",
  "9": "School Bus"
}

function routingProfileSelect() {

  // logic for which profiles to show in drop-down...
  function getItemsForSelect(scope) {
    const { route } = scope;
    debug("route:", route);
    if (route.routingProfileFromPrescribedRoute) {
      debug("route.routingProfileFromPrescribedRoute");
      route.routingProfiles.unshift(route.routingProfileFromPrescribedRoute); // aka 'Trip Options'
      route.selectedRoutingProfile = route.routingProfiles[0];
    }

    // if any RPs are companyProfile, select it
    const companyProfile = route.routingProfiles.find(rp => rp.source === "CompanyProfile")
    if (companyProfile) {
      route.selectedRoutingProfile = companyProfile;
    }

    let items = route.routingProfiles.map(rp => {
      if (!rp.name) { // use vehicleType as a backup name
        if (vehicleTypeMap[rp.vehicleType]) {
          rp.name = vehicleTypeMap[rp.vehicleType];
        } else {
          rp.name = rp.vehicleType;
        }
      }
      return rp;
    });

    // filter out Account-RPs when we have VehicleGroup-RPs
    const companyVehicleGroupRP = items.find(r => r.source === "CompanyProfile_VG");
    if (companyVehicleGroupRP) {
      items = items.filter(r => r.source !== "CompanyProfile_Acct");
    }

    // sets selectedRP when its needed
    if (companyVehicleGroupRP && !route.selectedRoutingProfile) {
      route.selectedRoutingProfile = companyVehicleGroupRP;
    }

    // if !rpId & !TripOptions & !selectedRP, add the 'Unknown profile'
    if (!route.routingProfileId && !route.routingProfileFromPrescribedRoute && !route.selectedRoutingProfile) {
      items.unshift({ name: "Unknown profile", source: "Default", vehicleType: "Truck"});
      route.unknownProfile = true;
      debug("no routingProfileId");
    }

    debug("items:", items);
    return items;
  }

  function sourceName() {
    const selectedRP = this.route.selectedRoutingProfile || {};
    if (selectedRP.source) {
      if (selectedRP.source.includes("Driver")) {
        return "Driver" // used to display to end-user
      } else if (selectedRP.source.includes("Company")) {
        return "Company"
      }
      return selectedRP.source
    }
  }

  function vehicleTypeName() {
    const selectedRP = this.route.selectedRoutingProfile || {};
    const vType = selectedRP.vehicleType;

    if (vehicleTypeMap[vType]) {
      return vehicleTypeMap[vType];
    }
    return vType;
  }

  function showLabel() {
    if (this.route.dropDownItems.length === 1) {
      return true;
    }
    const selectedRP = this.route.selectedRoutingProfile || {};
    // if source if company profile or trip options, show label
    return (selectedRP.source === "CompanyProfile" || selectedRP.source === "DriverProfile");
  }

  function showLabelWarning() {
    const { unknownProfile, dropDownItems } = this.route;
    const item = dropDownItems[0];
    if (item &&  item.source === "DriverProfile") {
      return true;
    }
    if (dropDownItems.length === 0 || unknownProfile) {
      return true;
    }
    return false;
  }

  function showDropDownWarning() {
    const selectedRP = this.route.selectedRoutingProfile;
    if (!selectedRP) {
      return true;
    }
    if (selectedRP.source === "DriverProfile") {
      return true;
    }
    if (selectedRP.source.includes("Company")) {
      return false;
    }
    if (this.route.unknownProfile) {
      return true;
    }

    return false;
  }

  function showDropDown() {
    // debug("$crtl", this.$ctrl)
    const route = this.route;
    if (!route || !route.routingProfiles) {
      return false;
    }

    const selectedRP = route.selectedRoutingProfile;
    if (selectedRP && selectedRP.source === "CompanyProfile") {
      return false;
    } else if (selectedRP && selectedRP.source === "DriverProfile") { // tripOptions from CP v10
      return false;
    }

    return route.dropDownItems.length > 1;
  }

  const directive = {
    template: require("./routingprofile-select.directive.html"),
    restrict: "E",
    scope: false, // use parent scope
    link: function(scope, element, attrs) {
      if (!scope.route) {
        scope.route = scope.$ctrl.route; // ensure scope.route exists, route-detail only has {route} on $ctrl
      }
      scope.showDropDown = showDropDown;
      scope.showLabel = showLabel;
      scope.showLabelWarning = showLabelWarning;
      scope.showDropDownWarning = showDropDownWarning;
      scope.vehicleTypeName = vehicleTypeName;
      scope.sourceName = sourceName;
      const items = getItemsForSelect(scope);
      scope.route.routingProfiles = items;
      scope.route.dropDownItems = items;

      // logic for setting selectedRoutingProfile
      if (scope.route.unknownProfile) {
        scope.route.selectedRoutingProfile = items[0];
      }
      debug("rp-select-> scope", scope);
    }
  };
  return directive;
}



// WEBPACK FOOTER //
// ./app/compliance/routingprofile-select.directive.js